import { FieldInfo } from '@/pages/maps/contexts/region-context'

export const isValidField = (field: FieldInfo): boolean =>
  field.diagnoses_count > 1

export const filterValidFields = (fields: FieldInfo[]): FieldInfo[] =>
  fields.filter(isValidField)
